import { AssetType } from '../../types/interfaces';
import { AssetTypeAssetParametersModel } from '../../types/interfaces/AssetTypeAssetParametersModel';
import { ObjectForSelection } from '../../types/interfaces/ObjectForSelection';
import IApiCalls from '../api/interfaces/apiCalls';

import BaseService from './BaseService';
import IAssetTypesService from './interfaces/AssetTypesService';
import ServiceResult from './interfaces/ServiceResult';

class AssetTypesService
  extends BaseService<AssetType>
  implements IAssetTypesService
{
  constructor(apiCalls: IApiCalls) {
    super(apiCalls, 'AssetTypes');
  }

  getForSelection(): ServiceResult<ObjectForSelection[] | undefined> {
    const apiCalls = this._apiCalls.beginApiCalls();
    return {
      result: apiCalls.AssetTypes.getForSelection(),
      cancel: apiCalls.cancelAllCalls
    };
  }

  getWithAssetParameter(
    id: number | undefined
  ): ServiceResult<AssetTypeAssetParametersModel> {
    const apiCalls = this._apiCalls.beginApiCalls();
    if (!id) {
      return {
        result: apiCalls.AssetParameters.getForSelection().then((x) => ({
          assetType: undefined,
          assetParameters: x
        })),
        cancel: apiCalls.cancelAllCalls
      };
    }
    const resultPromise = Promise.all([
      apiCalls.AssetTypes.get(id),
      apiCalls.AssetParameters.getForSelection()
    ]).then(
      ([assetType, assetParameters]): AssetTypeAssetParametersModel => ({
        assetType,
        assetParameters
      })
    );
    return { result: resultPromise, cancel: apiCalls.cancelAllCalls };
  }
}

export default AssetTypesService;
